import React, { useState } from "react";
import { Layout } from "antd";
import { useNavigate } from "react-router-dom";
import CustomIcon from "../../CustomIcon";
import SideMenu from "./SideMenu";
import { APP_VERSION } from "../../../settings/config";
import { useLocation } from "react-router-dom";

const { Sider } = Layout;

export default function SideMenuLayoutWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapsedMenu = () => {
        setCollapsed(!collapsed);
    };

    const seeAllPlans = () => {
        navigate("/subscription/plans");
    };

    const onMenuItemClick = (path) => {
        const websiteGuid = new URLSearchParams(window.location.search).get("w_guid");
        if (websiteGuid) {
            navigate({
                pathname: path,
                search: window.location.search
            });
        } else {
            navigate(path);
        }
    };

    return (
        <Sider className="general-layout-sidebar" collapsed={collapsed}>
            <div className="top-side-branding flexbox align-center space-between">
                <div className="logo" />
                <div className="menu-fold flexbox align-center justify-center" onClick={toggleCollapsedMenu}>
                    <CustomIcon name="menu-fold" className="icon" size="24" />
                </div>
            </div>

            <SideMenu selectedMenuItem={location.pathname} onMenuItemClick={onMenuItemClick} collapsed={collapsed} />

            <span className="app-version">{APP_VERSION}</span>

            {
                //TODO: Move the below code in a separate component
            }
            {props.subscription &&
                props.subscription["plan_code"] &&
                props.user &&
                props.user.email &&
                (!props.organization || (props.organization && props.organization["owner"] === props.user.email)) && (
                    <div className="package-container">
                        <span className="email">{props.user.email}</span>
                        <span className="plan">
                            {props.subscription["plan_settings"] && props.subscription["plan_settings"]["name"]}
                        </span>

                        <span className="see-all-plans" onClick={seeAllPlans}>
                            See all plans &rsaquo;
                        </span>
                    </div>
                )}

            {props.organization &&
                props.user &&
                props.organization["owner"] &&
                props.organization["owner"] !== props.user.email && (
                    <div className="team-container">
                        <div className="team-name">
                            <strong>Team:</strong> {props.organization["name"]}
                        </div>
                        <div className="team-owner">
                            <strong>Owner:</strong> {props.organization["owner"]}
                        </div>
                    </div>
                )}
        </Sider>
    );
}
